"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ethEnsNamehash = _interopRequireDefault(require("eth-ens-namehash"));

var _web3Utils = _interopRequireDefault(require("web3-utils"));

var _contract = _interopRequireDefault(require("./contract"));

var _EnsResolver = _interopRequireDefault([{
  inputs: [{
    name: "_ensAddr",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor",
  signature: "constructor"
}, {
  constant: true,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }, {
    name: "_kind",
    type: "bytes32"
  }],
  name: "has",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x41b9dc2b"
}, {
  constant: true,
  inputs: [{
    name: "_interfaceID",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function",
  signature: "0x01ffc9a7"
}, {
  constant: true,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }],
  name: "addr",
  outputs: [{
    name: "ret",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x3b3b57de"
}, {
  constant: false,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }, {
    name: "_addr",
    type: "address"
  }],
  name: "setAddr",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0xd5fa2b00"
}, {
  constant: true,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }],
  name: "content",
  outputs: [{
    name: "ret",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x2dff6941"
}, {
  constant: false,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }, {
    name: "_hash",
    type: "bytes32"
  }],
  name: "setContent",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0xc3d014d6"
}]);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EnsResolver = /*#__PURE__*/function (_Contract) {
  _inherits(EnsResolver, _Contract);

  var _super = _createSuper(EnsResolver);

  function EnsResolver(web3, address) {
    _classCallCheck(this, EnsResolver);

    return _super.call(this, web3, _EnsResolver["default"], address);
  }

  _createClass(EnsResolver, [{
    key: "addr",
    value: function addr(name) {
      return this.methods.addr(_ethEnsNamehash["default"].hash(name)).call().then(function (r) {
        return _web3Utils["default"].toChecksumAddress(r);
      });
    }
  }]);

  return EnsResolver;
}(_contract["default"]);

exports["default"] = EnsResolver;